module.exports = __webpack_public_path__ + "img/no-news.60b07355.png";